<template>
  <w-dialog
    :show="visible"
    @close="handleClose"
    class="ent-recommend-list"
    title="推荐预选账号"
    :wallStyle="{ zIndex: 2001 }"
    :box-style="{ width: '500px', zIndex: 2001 }"
    :bodyStyle="{ padding: '20px 0 0 0' }"
    :footerStyle="{ padding: '20px 24px', borderTop: 'none' }">
    <div>
      <div style="padding: 0 24px;">
        <div class="ent-explain-text">
          可选择预选账号获取对应产品权益，选择后将使用该账号体验企业级云端功能
        </div>
      </div>
      <w-scrollbar wrap-style="max-height: 394px;overflow-y: auto; overflow-x: hidden;" viewStyle="overflow-x: hidden;">
        <div style="padding: 0 24px;">
          <ul>
            <li v-for="product in products"
                :key="product.id"
                :class="{'is-active': productInfo.id === product.id}"
                @click="handleSelect(product)">
              <div class="recommend-hot" v-if="[1, 2].includes(product.type)"></div>
              <div class="recommend-icon">
                <i class="r2-icon-cmc_business"></i>
              </div>
              <div class="recommend-container flex-1">
                <template v-if="product.productUsedVos.length">
                  <div class="recommend-item__tags" :style="product.account ? {} : {padding: '8px 0'}">
                    <span class="recommend-item__tag"
                          v-for="asset in product.productUsedVos.slice(0, 2)"
                          :key="asset.productName">
                      {{asset.productName}}
                    </span>
                    <el-tooltip effect="dark" v-if="product.productUsedVos.length > 2">
                      <div class="product-list" slot="content">
                        <ul>
                          <li class="flex">
                            <div class="product-name flex-1 ellipsis font-14" style="color: rgba(255, 255, 255, 0.55);">产品名称</div>
                            <div class="product-last-date font-14" style="color: rgba(255, 255, 255, 0.55);">到期时间</div>
                          </li>
                        </ul>
                        <ul style="max-height: 240px; overflow-x: hidden; overflow-y: auto;">
                          <li class="flex"
                              v-for="asset in product.productUsedVos"
                              :key="asset.productName">
                            <div class="product-name flex-1 ellipsis font-14">{{asset.productName}}</div>
                            <div class="product-last-date font-12">{{asset.endDate | formatDate}}</div>
                          </li>
                        </ul>
                      </div>
                      <span class="recommend-item__tag" style="color: #2079FA;">+{{product.productUsedVos.length - 2}}</span>
                    </el-tooltip>
                  </div>
                </template>
                <div class="recommend-item__username ellipsis"
                     v-if="product.account"
                     :style="product.productUsedVos.length ? {} : {lineHeight: '40px', height: '40px'}">
                  {{product.account}}
                </div>
              </div>
            </li>
          </ul>
          <div class="relative" style="min-height: 150px;" v-if="products.length === 0">
            <no-data/>
          </div>
        </div>
      </w-scrollbar>
    </div>
    <div slot="footer" class="text-align-right">
      <a href="javascript: void(0);" class="binding-username" @click="handleBindingAccount()">绑定已有账号</a>
      <w-button size="small" type="minor" @click="handleCreate()">创建新账号</w-button>
      <w-button size="small" type="primary" @click="handleSubmit()" :disabled="productInfo.id === undefined">使用预选账号</w-button>
      <!--核心功能使用次数-->
      <!--活动时间-->
      <!--资产客户群-->
      <!--新手-->
    </div>
  </w-dialog>
</template>

<script>
import {isEmptyObject} from '@/assets/utils'
import {formatDate} from '@/assets/utils/Date'
import {NoData} from '@/components/common'

export default {
  name: 'RecommendList',
  components: {
    NoData
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: () => ([])
    }
  },
  filters: {
    formatDate (time) {
      return formatDate(new Date(time), 'yyyy-MM-dd')
    }
  },
  data () {
    return {
      productInfo: {}
    }
  },
  watch: {
    products: {
      handler (value) {
        if (value.length > 0) {
          this.productInfo = value[0]
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 取消
    handleClose () {
      this.productInfo = {}
      this.$emit('close')
    },
    // 选择
    handleSelect (item) {
      this.productInfo = item
    },
    // 绑定已有账号
    handleBindingAccount () {
      this.sentLog(100117108)
      this.$emit('binding-account')
    },
    // 使用预选账号
    handleSubmit () {
      this.sentLog(100117106)
      if (!isEmptyObject(this.productInfo)) {
        this.$emit('submit', this.productInfo)
      } else {
        this.$message.warning('请选择预选账号')
      }
    },
    // 创建新账号
    handleCreate () {
      this.sentLog(100117107)
      this.$emit('create')
    }
  }
}
</script>

<style lang="less" scoped>
  .ent-recommend-list {
     ul {
      li {
        display: flex;
        /*width: 452px;*/
        min-height: 66px;
        padding: 0 14px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid rgba(33, 37, 48, 0.15);
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        &:hover, &.is-active {
          background: rgba(32, 121, 250, 0.15);
          border-color: #2079FA;
        }
        + li {
          margin-top: 12px;
        }
        .recommend-hot {
          position: absolute;
          width: 44px;
          height: 44px;
          right: -2px;
          top: -2px;
          background-image: url("~@/assets/images/indexpage/joinEnt/recommend.png");
          background-size: contain;
        }
        .recommend-icon {
          margin: 13px 0;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #2079fa;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
        }
        .recommend-container {
          margin: 10px 0 6px 12px;
          min-height: 40px;
        }
        .recommend-item__tag {
          display: inline-block;
          height: 28px;
          padding: 3px 8px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #DEDFE0;
          font-size: 14px;
          font-weight: 400;
          color: #212530;
          line-height: 22px;
          box-sizing: border-box;
          & + .recommend-item__tag {
            margin-left: 8px;
          }
        }
        .recommend-item__username {
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(33, 37, 48, 0.8);
          line-height: 20px;
        }
      }
    }
  }
  .binding-username {
    font-size: 14px;
    font-weight: 400;
    color: #2079FA;
    line-height: 32px;
    float: left;
    &:hover {
      color: #4c93fb;
    }
  }
  .product-list {
    width: 207px;
    ul {
      li {
        line-height: 24px;
        .product-name {
          padding-right: 20px;
          font-weight: 400;
          color: #FFFFFF;
        }
        .product-last-date {
          width: 65px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.75);
        }
      }
    }
  }
</style>
